import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Icons } from '../../../shared/helpers/icons';
import { EStage, EStatus } from '../../../shared/models/types.enum';
import { IAssessCase } from '../../../shared/models/assessCase';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { AssessCaseService } from '../../../shared/services/assessCase.service';
import { FormUtils } from '../../../shared/helpers/formUtils';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { PopupMessageComponent } from '../../components/popup-message/popup-message.component';
declare var initFlowbite: any;

@Component({
  selector: 'closed-dashboard',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    LucideAngularModule,
    SpinnerComponent,
    PopupMessageComponent,
    NgxPaginationModule
  ],
  templateUrl: './closed-dashboard.component.html',
  styleUrl: './closed-dashboard.component.css'
})
export class ClosedDashboardComponent implements OnInit {

  icons = Icons;
  stageEnum = EStage;
  statusEnum = EStatus;
  currentBuildingId: string | null = null;
  searchQuery: string = '';
  caseTypeFilter: 'all' | 'internal' | 'external' = 'all'; // external cases were uploaded, internal ones went through the Assess forms
  closingCases: IAssessCase[] = [];
  filteredClosingCases: IAssessCase[] = [];
  selectedCase: IAssessCase | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;
  page = 1;
  itemsPerPage = 10;

  sortOrder: boolean = true;
  showTeam: boolean = false;
  showReviewRequest: boolean = false;
  showReviewModal: boolean = false;
  showCancelReview: boolean = false;
  loading: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private userDataService: UserDataService,
    private assessCaseService: AssessCaseService,
    private formUtils: FormUtils
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.loadClosedCases();
  }

  loadClosedCases(): void {
    // get all case and filter by current stage at first loading
    if (this.currentBuildingId) {
      this.loading = true;
      this.assessCaseService.getBuildingAssessCases(this.currentBuildingId).subscribe({
        next: (response) => {
          this.loading = false;
          if (!response.message) {
            this.closingCases = response.filter((item: IAssessCase) => item.current_stage === EStage.Closed);
            if (isPlatformBrowser(this.platformId)) { // refresh flowbite effects (tooltip) only in browser
              setTimeout(() => {
                initFlowbite();
              }, 100);
            }
            this.filteredClosingCases = this.closingCases.length > 0 ? this.closingCases.reverse() : [];
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Error fetching building closed cases:', error);
          this.popupMessage = error.message
          this.messageModal = 'unsuccess';
        }
      });
    } else {
      return
    }
  }

  sortList(key: keyof typeof this.filteredClosingCases[0]): void {
    this.sortOrder = !this.sortOrder;
    this.filteredClosingCases.sort((a, b) => {
      const valueA = a[key]?.toString().toLowerCase() || '';
      const valueB = b[key]?.toString().toLowerCase() || '';

      if (valueA < valueB) {
        return this.sortOrder ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortOrder ? 1 : -1;
      }
      return 0;
    });
  }

  filterAssessCases(): void {
    this.filteredClosingCases = this.closingCases.filter((caseItem) => {
      if (this.caseTypeFilter === 'external' && !caseItem.is_uploaded) return false;
      if (this.caseTypeFilter === 'internal' && caseItem.is_uploaded) return false;
      return (
        caseItem.case_id.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        caseItem.detail_of_situation?.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        caseItem.created_by_name?.toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    });
  }
  
  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }

}
